import { render, staticRenderFns } from "./ExtraMealOrder.vue?vue&type=template&id=c315bfac&scoped=true&"
import script from "./ExtraMealOrder.vue?vue&type=script&lang=ts&"
export * from "./ExtraMealOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c315bfac",
  null
  
)

export default component.exports